import { useEffect } from 'react';

import { useOptionalRealmProfile } from '@/realm-profile/context';
import { resolveRealmTitle } from '@/realm-profile/profile';

export interface DocumentTitleProps {
  separator?: string;
  suffix?: string;
  title?: string;
}

/** buildDocumentTitle 组合页面标题与应用品牌标题。 */
function buildDocumentTitle({ separator = ' - ', suffix, title }: DocumentTitleProps) {
  const pageTitle = title?.trim();
  const appTitle = suffix?.trim();

  if (pageTitle && appTitle && pageTitle !== appTitle) return `${pageTitle}${separator}${appTitle}`;
  return pageTitle || appTitle || '';
}

/** buildRealmDocumentTitle 优先使用渠道发布的标题模板，首页只显示渠道标题。 */
function buildRealmDocumentTitle(
  props: DocumentTitleProps,
  realmTitle: string,
  titleTemplate?: string,
): string {
  const pageTitle = props.title?.trim();
  if (pageTitle && titleTemplate?.includes('%s')) return titleTemplate.replace('%s', pageTitle);
  return buildDocumentTitle({ ...props, suffix: realmTitle || props.suffix });
}

/** 页面挂载时更新浏览器标题，并在路由切换或离开页面时还原标题。 */
export function DocumentTitle(props: DocumentTitleProps) {
  const { separator = ' - ', suffix, title } = props;
  const profile = useOptionalRealmProfile()?.profile;
  const realmTitle = resolveRealmTitle(profile) || '';
  const titleTemplate = profile?.webProfile.documentMeta.titleTemplate;

  useEffect(() => {
    const previousTitle = document.title;
    const nextTitle = buildRealmDocumentTitle({ separator, suffix, title }, realmTitle, titleTemplate);
    if (nextTitle) document.title = nextTitle;

    return () => {
      document.title = previousTitle;
    };
  }, [realmTitle, separator, suffix, title, titleTemplate]);

  return null;
}
